export const statusBarHeight = 30
export const headerHeight = 80
export const sidebarWidth = 280
export const pageContentMaxWidth = 1400